// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__RsH6x","root":"styles_root__1Puio","card":"styles_card__2eb9D","title":"styles_title__1qDkP","buttonBlock":"styles_buttonBlock__3sJK-"};